import { render, staticRenderFns } from "./LotteryMange.vue?vue&type=template&id=ef77e4b8&scoped=true"
import script from "./LotteryMange.vue?vue&type=script&lang=js"
export * from "./LotteryMange.vue?vue&type=script&lang=js"
import style0 from "./LotteryMange.vue?vue&type=style&index=0&id=ef77e4b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef77e4b8",
  null
  
)

export default component.exports